import "./styles.scss";

import React from "react";
import { Dropdown } from "react-bootstrap";

// #region PastDaysInput

export function PastDaysInput({ value, onChange, errorRelativePeriod, onClearError }) {
  return (
    <div className="period-input-flex">
      <span className="period-label-muted">Últimos</span>
      <input
        type="number"
        value={`${value ? Math.abs(Number(value)) : ""}`}
        onChange={onChange}
        onFocus={onClearError}
        className={`form-control period-input ${errorRelativePeriod ? "is-invalid" : ""}`}
      />
      <span className="period-label-muted">dias</span>
    </div>
  );
}

// #endregion

// #region FutureDaysInput
export function FutureDaysInput({ value, onChange, errorRelativePeriod, onClearError }) {
  return (
    <div className="period-input-flex">
      <span className="period-label-muted">Próximos</span>
      <input
        type="number"
        value={`${value ? Math.abs(Number(value)) : ""}`}
        onChange={onChange}
        onFocus={onClearError}
        className={`form-control period-input ${errorRelativePeriod ? "is-invalid" : ""}`}
      />
      <span className="period-label-muted">dias</span>
    </div>
  );
}

// #endregion

// #region CustomPeriodInput

export function CustomPeriodInput({
  from,
  fromType,
  to,
  toType,
  onChangeFrom,
  onChangeFromType,
  onChangeTo,
  onChangeToType,
  errorFromValue,
  errorFromType,
  errorToValue,
  errorToType,
  onClearError,
}) {
  return (
    <div className="period-input-row">
      <span className="period-label">De</span>
      <input
        type="number"
        value={`${from ? Math.abs(Number(from)) : ""}`}
        onChange={onChangeFrom}
        onFocus={() => onClearError("errorFromValue")}
        className={`form-control period-input ${errorFromValue ? "is-invalid" : ""}`}
      />
      <Dropdown
        onSelect={onChangeFromType}
        className={`period-dropdown ${errorFromType ? "erroStatus" : ""}`}
      >
        <Dropdown.Toggle
          variant="outline-secondary"
          id="from-type"
          className={`period-dropdown-toggle ${errorFromType ? "is-invalid" : ""}`}
          onFocus={() => onClearError("errorFromType")}
        >
          {fromType === "pastDays"
            ? "Dias passados"
            : fromType === "futureDays"
            ? "Dias à frente"
            : "Selecione"}
        </Dropdown.Toggle>
        <Dropdown.Menu className="period-dropdown-menu">
          <Dropdown.Item eventKey="pastDays">Dias passados</Dropdown.Item>
          <Dropdown.Item eventKey="futureDays">Dias à frente</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <span className="period-label period-label-nowrap">até</span>
      <input
        type="number"
        value={`${to ? Math.abs(Number(to)) : ""}`}
        onChange={onChangeTo}
        onFocus={() => onClearError("errorToValue")}
        className={`form-control period-input ${errorToValue ? "is-invalid" : ""}`}
      />
      <Dropdown
        onSelect={onChangeToType}
        className={`period-dropdown ${errorToType ? "erroStatus" : ""}`}
      >
        <Dropdown.Toggle
          variant="outline-secondary"
          id="to-type"
          className={`period-dropdown-toggle ${errorToType ? "is-invalid" : ""}`}
          onFocus={() => onClearError("errorToType")}
        >
          {toType === "futureDays"
            ? "Dias à frente"
            : toType === "pastDays"
            ? "Dias passados"
            : "Selecione"}
        </Dropdown.Toggle>
        <Dropdown.Menu className="period-dropdown-menu">
          <Dropdown.Item eventKey="futureDays">Dias à frente</Dropdown.Item>
          <Dropdown.Item eventKey="pastDays">Dias passados</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export const SelectPeriodInterval = ({
  condicione,
  selectDropdown,
  errorRelativePeriod,
  errorFromValue,
  errorFromType,
  errorToValue,
  errorToType,
  onClearErrors,
}) => {
  
  if (condicione?.periodType === "today") {
    return null;
  }

  if (condicione?.periodType === "pastDays") {
    return (
      <PastDaysInput
        value={condicione?.start}
        onChange={(e) => {
          const value = Math.max(0, Number(e.target.value));
          selectDropdown(value, "start");
        }}
        errorRelativePeriod={errorRelativePeriod}
        onClearError={() => onClearErrors && onClearErrors("errorRelativePeriod")}
      />
    );
  }

  if (condicione?.periodType === "futureDays") {
    return (
      <FutureDaysInput
        value={condicione?.end}
        onChange={(e) => {
          const value = Math.max(0, Number(e.target.value));
          selectDropdown(value, "end");
        }}
        errorRelativePeriod={errorRelativePeriod}
        onClearError={() => onClearErrors && onClearErrors("errorRelativePeriod")}
      />
    );
  }

  if (condicione?.periodType === "custom") {
    return (
      <CustomPeriodInput
        from={condicione?.start}
        fromType={condicione?.periodCustomFromType}
        to={condicione?.end}
        toType={condicione?.periodCustomToType}
        onChangeFrom={(e) => {
          const value = Math.max(0, Number(e.target.value));
          selectDropdown(value, "start");
        }}
        onChangeFromType={(e) => selectDropdown(e, "periodCustomFromType")}
        onChangeTo={(e) => {
          const value = Math.max(0, Number(e.target.value));
          selectDropdown(value, "end");
        }}
        onChangeToType={(e) => selectDropdown(e, "periodCustomToType")}
        errorFromValue={errorFromValue}
        errorFromType={errorFromType}
        errorToValue={errorToValue}
        errorToType={errorToType}
        onClearError={(errorType) => onClearErrors && onClearErrors(errorType)}
      />
    );
  }

  return null;
};

// #endregion
